import { supabase } from '@/integrations/supabase/client';

export const TELEMETRY_ONBOARDING_RETURN = 'arcanix.telemetryOnboarding';

export interface TeamGameProfile {
  team_id: string;
  genre: string | null;
  platforms: string[];
  team_size: string | null;
  stage: string | null;
  data_sources: string[];
}

export async function getTeamGameProfile(teamId: string): Promise<TeamGameProfile | null> {
  const { data, error } = await (supabase as any)
    .from('team_game_profiles')
    .select('team_id, genre, platforms, team_size, stage, data_sources')
    .eq('team_id', teamId)
    .maybeSingle();
  if (error) throw error;
  return data as TeamGameProfile | null;
}

export async function saveTeamGameProfile(profile: TeamGameProfile): Promise<void> {
  const { error } = await (supabase as any)
    .from('team_game_profiles')
    .upsert(profile, { onConflict: 'team_id' });
  if (error) throw error;
}

/** Founding team admins with no saved game profile still need telemetry setup. */
export async function teamNeedsTelemetryOnboarding(userId: string, teamId: string): Promise<boolean> {
  const { data: membership, error } = await supabase
    .from('memberships')
    .select('is_admin, invited_by_id')
    .eq('user_id', userId)
    .eq('team_id', teamId)
    .maybeSingle();
  if (error || !membership?.is_admin || membership.invited_by_id != null) return false;
  const existing = await getTeamGameProfile(teamId);
  return !existing;
}
